/// <amd-module name="Analytics/Shared/TrendChart/Common/DurationConverter" />
export class DurationConverter {
    public static convertSecondsToMinutes(durationInSeconds: number) {
        return durationInSeconds / 60.0;
    }

    public static convertSecondsToHours(durationInSeconds: number) {
        return durationInSeconds / (60.0 * 60.0);
    }
}
